export default __webpack_public_path__ + "static/media/640_dummy2016-goldschmiede01-de.cba046bb.png";